exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.panel-content[data-v-566fc0a8] .v-expansion-panel-content__wrap {\n    margin: 0;\n    padding: 0;\n}\n", ""]);

